import { usePlaylists } from "@/lib/api";
import { Skeleton } from "@mui/material";
import dynamic from 'next/dynamic'

const PlaylistSwiper = dynamic(() => import('./PlaylistSwiper'))

const PlaylistSection = ({playlistCategory, imageRatioSquare, ...props}) => {
    const { playlists, isLoading, isError } = usePlaylists([], [playlistCategory.id]);

    if (isLoading) {
        return <Skeleton />
    }

    return <PlaylistSwiper playlists={playlists} imageRatioSquare={true} />;
}

export default PlaylistSection;